/**
 * One HWZ-LOG id for this browser tab.
 * Sent only as X-Hubwayz-Attempt-Id to our backend. Never merged into the supplier body.
 */

export const HUBWAYZ_ATTEMPT_HEADER = "X-Hubwayz-Attempt-Id";

const STORAGE_KEY = "hubwayzSessionLogAttemptId";

let memoryId = "";

function randomId() {
  const rand = Math.random().toString(16).slice(2, 10);
  return `HWZ-LOG-${Date.now()}-${rand}`;
}

function writeId(id) {
  memoryId = id;
  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(STORAGE_KEY, id);
    }
  } catch {
    /* private mode or blocked storage */
  }
  return id;
}

/** New folder for a new Search. Later Pre-Book and Book in this tab reuse it. */
export function beginHubwayzSessionLogAttempt() {
  return writeId(randomId());
}

export function currentHubwayzSessionLogAttempt() {
  try {
    if (typeof sessionStorage !== "undefined") {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        memoryId = stored;
        return stored;
      }
    }
  } catch {
    /* ignore */
  }
  if (memoryId) return memoryId;
  return beginHubwayzSessionLogAttempt();
}

/** Header for our API only. Does not add fields to a supplier payload. */
export function hubwayzAttemptHeaders() {
  return { [HUBWAYZ_ATTEMPT_HEADER]: currentHubwayzSessionLogAttempt() };
}
